import React from 'react';
import { PainSection } from './PainSection';
import { ProductIntro } from './ProductIntro';
import { TomosSection } from './TomosSection';
import { BonosSection } from './BonosSection';
import { ValueStack } from './ValueStack';
import { AudienceSection } from './AudienceSection';
import { Testimonials } from './Testimonials';
import { HowItWorks } from './HowItWorks';
import { Guarantee } from './Guarantee';
import { ClosingBlock } from './ClosingBlock';
import { FAQ } from './FAQ';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
import { FloatingCTA } from './FloatingCTA';
export function DeferredLanding() {
  return <>
      <PainSection data-id="element-83" data-mp="121klfcg54i9y" />
      <ProductIntro data-id="element-84" data-mp="x0wu0po01zf7" />
      <TomosSection data-id="element-85" data-mp="x1ohtebcusux" />
      <BonosSection data-id="element-86" data-mp="x16n4m4ccmp4" />
      <ValueStack data-id="element-87" data-mp="x2q3sdtwszrf" />
      <AudienceSection data-id="element-88" data-mp="1bxxhggz5r87v" />
      <Testimonials data-id="element-89" data-mp="1bx4hpzym9iz8" />
      <HowItWorks data-id="element-90" data-mp="1bypc9pkxl1x3" />
      <Guarantee data-id="element-91" data-mp="1by5v4b33uhk4" />
      <ClosingBlock data-id="element-92" data-mp="1bvjocdo1g62y" />
      <FAQ data-id="element-93" data-mp="16zcpt5xz1wv1" />
      <FinalCTA data-id="element-94" data-mp="16zm5o0paynn0" />
      <Footer data-id="element-95" data-mp="170485f2k5y3d" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-96" data-mp="170nsf2fokykk" />
      <FloatingCTA data-id="element-97" data-mp="1xxoyspelz50k" />
    </>;
}